import "../../main";
import $ from 'jquery';
import _ from 'underscore';
import { Ajax, Modal } from 'rustig'
import { Providers, IProvider, IProviderData } from "./providers"
import { Hospitals, IHospital } from "./hospitals"
import { Counties } from "./counties"
import { ZoomLevel } from "../map/marker"

export class ProviderLocator {
  filter: Filter;
  map: Map;
  listView: ListView;

  public constructor() {
    this.filter = new Filter();
    this.listView = new ListView($('[data-list-view]'));
    this.map = new Map();
  }

  public static promptForCurrentLocation() : void {
    navigator.geolocation.getCurrentPosition(
      pos => {
        let $form = $('#setLocationForm');
        $form.find('#latitude').val(pos.coords.latitude);
        $form.find('#longitude').val(pos.coords.longitude);
        $form.remote();
      },
      err => console.log(err));
  }

  public static init() : void { // callback fired when google maps api is ready
    new ProviderLocator();
  }
}

class Filter {
  $form: JQuery;
  formData: string;

  public constructor() {
    this.$form = $('form');

    $(document).on('refresh-providers', () => {
      this.formData = this.getsFormData();
      this.$form.find('apply'.asDataSelector()).addClass('display-none');
    });
    $(document).on('change', '[data-filter-sidebar] input', this.showsOrHidesSubmitButton.bind(this));
    $(document).on('category-replaced', this.showsOrHidesSubmitButton.bind(this));
  }

  getsFormData(): string {
    return this.$form.find('input:not([type="hidden"])').serialize();
  }

  showsOrHidesSubmitButton(): void {
    let data = this.getsFormData();
    let $submitButton = this.$form.find('apply'.asDataSelector());

    if (data !== this.formData)
      $submitButton.removeClass('display-none');
    else
      $submitButton.addClass('display-none');
  }
}

class Map {

  map: google.maps.Map;
  providers: Providers;
  hospitals: Hospitals;
  counties: Counties;

  constructor() {
    this.map = new google.maps.Map($('[data-map]')[0], {
      center: UnitedStates.Center,
      zoom: ZoomLevel.Continent,
      mapId: window.GoogleMapId,
    });

    this.providers = new Providers(this.map, new Array<IProvider>());
    this.setsUpPreferences();
    this.addsLegend();
  }

  setsUpPreferences(): void {
    this.counties = new Counties(this.map);
    this.hospitals = new Hospitals(this.map, new Array<IHospital>());
  }

  addsLegend() {
    let $legend = $(`<div class="legend">
                        <span class="icon-stack">
                          <i class="icon-star star-1"></i>
                          <span class="rating">1</span>
                        </span>
                        <span class="icon-stack">
                          <i class="icon-star star-2"></i>
                          <span class="rating">2</span>
                        </span>
                        <span class="icon-stack">
                          <i class="icon-star star-3"></i>
                          <span class="rating">3</span>
                        </span>
                        <span class="icon-stack">
                          <i class="icon-star star-4"></i>
                          <span class="rating">4</span>
                        </span>
                        <span class="icon-stack">
                          <i class="icon-star star-5"></i>
                          <span class="rating">5</span>
                        </span>
                      </div>`);
    this.map.controls[google.maps.ControlPosition.LEFT_CENTER].push($legend[0]);
    let showHideLegendBasedOnZoomLevel = () => {
      if (this.map.getZoom() < ZoomLevel.State + 1)
        $legend.addClass('display-none');
      else
        $legend.removeClass('display-none');
    };
    showHideLegendBasedOnZoomLevel();
    google.maps.event.addListener(this.map, 'zoom_changed', showHideLegendBasedOnZoomLevel);
  }
}

class UnitedStates {
  public static get Center(): google.maps.LatLng { return new google.maps.LatLng(39.8283, -98.5795); }
}

class ListView {
  $element: JQuery;
  children: Array<JQuery>;

  public constructor($element: JQuery) {
    this.$element = $element;
    this.children = new Array<JQuery>();

    $(document).on('refresh-providers', (event: Event, data?: IProviderData) => {
      this.updateTable(data.Facilities);
      $('[data-list-info-panel]').html(null);
    });
  }

  updateTable(facilities: Array<IProvider>): void {
    this.children.forEach(x => x.remove());

    _.sortBy(facilities, x => x.Name).forEach(x => {
      let $row = this.buildRow(x);
      this.children.push($row);
      this.$element.append($row);
    });
  }

  buildRow(provider: IProvider): JQuery {
    return $(`
<tr class="cursor-pointer">
  <td class="tu-1 flex-row">
    <div class="star-rating">
      <span class="star-rating-count">${provider.StarRating || ''}</span>
      <i class="icon-star stars-filled icon-lg"></i>
    </div>
    <div class="flex-grow-1">
      ${provider.Name}
      <div class="text-caption">${provider.Type}</div>
      ${provider.Address}<br />
      ${provider.PhoneNumber}      
    </div>
  </td>
</tr>
`).on('click.provider-locator', () => Ajax.execute({ url: provider.Url }));
  }
}

export interface ILocation {
  Latitude: number;
  Longitude: number;
}
